export default {
    filesSelect: {
        files: "Файлы",
        download: "Загрузить",
        moreThanOneSignificantFile: "Больше чем один значимый файл, автозагрузка не сработает",
    },
    multiTaskPresets: {
        presets: "Пресеты",
        saveAs: "Сохранить как",
        edit: "Редактировать",
        delete: "Удалить",
        apply: "Применить",
        enterPresetName: "Введите название пресета",
        cancellation: "Отмена",
        dataForPresetNotSelected: "Не выбраны данные для пресета",
        presetWithThisNameAlredyExist: "Пресет с таким именем уже существует",
        selectedNewElements: "Выбраны новые элементы?",
        deleteSelectedPreset: "Удалить выбранный пресет?",
    },
    resultLogButton: {
        result: "Результат"
    },
    runTaskForm: {
        close: "Закрыть",
        cancel: "Отменить",
        start: "Запуск",
        accept: "Подтвердить",
        fileSelect: "Выбор файла",
        dataBase: "База данных",
        fileSelect: "Выбор файла",
        comment: "Комментарий",
        cmdLine: "Строка cmdLine:",
        taskStarted: "Задача запущена",
        taskCompleted: "Задача завершена",
        withError: "с ошибкой",
        taskHelp: "Помощь по задаче",
        launchOnAllBases: "Запуск на всех базах",
        fileMustBePresent: "Должен присутствовать файл",
        inappropriateNumberFormat: "Неподходящий формат числа в строке номер",
        inappropriateFloatFormat: "Неподходящий формат числа с плавающей точкой в строке номер",
        allFieldsMustBeEntered: "Все поля должны быть введены",
        checkFieldsContent: "Проверьте содержимое полей!",
        oneOrAllFieldsNotFilled: "Одно или несколько полей незаполнены",
        noAppTypeInFileName: "Не найдено типа приложения в названии файла, принимается как admin",
        uncorrectFileForAppRefresh: "Неверный файл обновления для текущего приложения",
        plsRefreshPage: "Обновите, пожалуйста, страницу",
        noHelpOnThisTaskCtrlEnter: "На данную задачу нет помощи. Ctrl+Enter - запуск задачи"
    },
    statusGrid: {
        files: "Файлы",
        download: "Скачать",
        watchLog: "Смотреть лог",
        delete: "Удалить",
        deleteSelected: "Удалить только выбранные задачи",
        restore: "Восстановить",
        emptyTrash: "Очистить корзину",
        zombies: {
            emergency: "Внештатная ситуация",
            clearZombies: "Очистить зависшие задачи",
            withHttp: 'Удалять на недоступных серверах',
            withoutHttp: 'Не удалять на недоступных серверах',
            noTasksNoProblems: "Зависших задач не удалено, проблем не найдено",
            tasksCleared: "Прервано зависших задач: {number}",
            tasksAndZombies: "Прервано зависших задач: {number}, найдено зомби-процессов: {zombie}",
            zombies: "Найдено зомби-процессов: {zombie}",
            noTasksCleared: "Зависших задач не найдено",
            errorsOnServers: "Найдены ошибки на серверах",
            warningsServers: "Сообщения от серверов:",
            tasksInfo: "Информация об этих задачах находится в Статус задач — Завершенные, поле Примечание",
            goToAdmin: "Просьба сообщить разработчикам (консультанту по Linux) для снятия зомби-процессов и освобождения ресурсов"
        },
        view: "Вид",
        compact: "Оптимальный",
        full: "Полный",
        refresh: "Обновить",
        leaveInLast: "Оставить за последние",
        days: "дней",
        completed: "завершенные",
        stated: "запущенные",
        thisActionRemoveAllToTrash: "Это действие перенесет в корзину все",
        tasksAfter: "задачи после",
        daysFromToday: "дня(-ей) от сегодня",
        attention: "Внимание",
        cancellation: "Отмена",
        uncorrectNumberOfDays: "Неверно указано число дней",
        willRemove: "удалит выбранную | удалит выбранные",
        willRestore: "восстановит выбранную | восстановит выбранные",
        willCleanse: "очистит выбранную | очистит выбранные",
        thisAction: "Это действие {action} {task}. Продолжать?",
        thisTask: "задачу | задачи",
        continue: "Продолжить",
        cancel: "Назад",
        thisActionCleanseAllRemovedTasks: "Это действие очистит все удаленные задачи. Продолжать?",
        thisActionCleanseSelectedRemovedTasks: "Это действие очистит выбранную удаленную задачу. Продолжать? | Это действие очистит выбранные удаленные задачи. Продолжать?"
    },
    taskStatus: {
        completedTaskResult: "Результаты выполнения задачи",
        taskStarted: "задача запущена",
        taskCompleted: "задача завершена",
        timeoutExceeded: "превышен таймаут",
        taskTerminatedAbnormally: "задача аварийно завершена",
        taskInProcess: "Данная задача в процессе работы",
        thisTaskTimedOut: "Данная задача превысила таймаут веб-страницы",
    }
}